import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { setMessage } from "./messages";

import galleryService from "../services/gallery.service";


export const getAlbums = createAsyncThunk(
    "get-albums",
    async (thunkAPI) => {
        try {
            const data = await galleryService.getAlbums();
            return { user: data.data.data };
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue();
        }
    }
);

export const getGallery = createAsyncThunk(
    "get-member-details",
    async (album_id, thunkAPI) => {
        try {
            const data = await galleryService.getGallerybyAlbum(album_id);
            return { user: data.data.data };
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue();
        }
    }
);

const initialState = { albums: null, gallery: null };

const gallerySlice = createSlice({
    name: "gallery",
    initialState,
    extraReducers: {
        [getAlbums.fulfilled]: (state, action) => {
            state.albums = action.payload.user;
        },
        [getAlbums.rejected]: (state, action) => {
            state.albums = null;
        },
        [getGallery.fulfilled]: (state, action) => {
            state.gallery = action.payload.user;
        },
        [getGallery.rejected]: (state, action) => {
            state.gallery = null;
        },
    },
});

const { reducer } = gallerySlice;
export default reducer;
